var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/user"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.339 9.553V9.14c0-4.219 3.423-7.639 7.647-7.639 4.223 0 7.647 3.42 7.647 7.639v.414m-15.294 0h-.173C2.398 9.553 1 11.023 1 12.793c0 1.77 1.398 3.24 3.166 3.24h.173m0-6.48v6.48m0 0h.038c.386 3.48 3.673 6.467 7.609 6.467 3.935 0 7.222-2.988 7.609-6.467h.038m0 0h.201c1.768 0 3.166-1.47 3.166-3.24 0-1.77-1.398-3.24-3.166-3.24h-.201m0 6.48v-6.48M9.339 18.91c.657.59 1.551.945 2.525.945 1.592 0 2.995-.956 3.457-2.354m-4.22-3.873c-.49.66-.155 1.924.763 2.141m4.646-8.293c-.762-1.031-2.416-.982-3.262-.223m-5.55-.937c.762-.821 2.417-.782 3.262-.178m-.348 4.411c0-2.072-2.582-2.072-2.582 0 0 1.966 2.582 1.966 2.582 0Zm5.236 0c0-2.072-2.582-2.072-2.582 0 0 1.983 2.582 1.983 2.582 0Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user_2.3436d672e9e5003650a4f03eb00f83ed.svg";
export { ForwardRef as ReactComponent };